export default __webpack_public_path__ + "static/media/Head_2_Ear_3_C4.bf6bc035.svg";